// Started from shadcn/ui (new-york-v4) "input", restyled to Union (design system artifact:
// components/Field). Use inside a Field so it has a label above and help below; the
// placeholder is an example, never the label.

import { cn } from "@union/ui/lib/utils";
import type * as React from "react";

/** Shared by Input, Textarea and SelectTrigger, so every field looks the same. */
export const fieldControl = cn(
  "w-full min-w-0 rounded-sm border-[1.5px] border-input bg-card px-space-3 type-body text-foreground",
  "transition-colors duration-150 placeholder:text-faint-foreground",
  "disabled:cursor-not-allowed disabled:bg-muted disabled:text-faint-foreground",
  "aria-invalid:border-destructive",
);

function Input({ className, type, ...props }: React.ComponentProps<"input">) {
  return (
    <input
      type={type}
      data-slot="input"
      className={cn(
        fieldControl,
        "h-tap-min data-[size=sm]:h-9",
        "file:mr-space-2 file:border-0 file:bg-transparent file:type-label file:text-foreground",
        className,
      )}
      {...props}
    />
  );
}

export { Input };
